import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { RequirementListRequirementFieldsFragmentDoc } from '../../../fragments/requirementListRequirementFields.generated';
import { FieldsToEditRequirementFragmentDoc } from '../../../fragments/fieldsToEditRequirement.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllRequirementsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllRequirementsQuery = { __typename?: 'Query', requirements: Array<{ __typename?: 'Requirement', createdAt?: any | null, id: string, name: string, requirementId?: string | null, status: Types.RequirementStatus, category: Types.RequirementCategory, definition?: string | null, modifiedAt?: any | null, version?: string | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, systemLevels: Array<{ __typename?: 'SystemLevel', id: string, name: string, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, successor?: { __typename?: 'Requirement', id: string, name: string } | null, childrenRefs?: Array<{ __typename?: 'Requirement', id: string, version?: string | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, regulations?: Array<{ __typename?: 'Regulation', id: string, regulationNumber: string }> | null, regulatoryDocuments?: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string }> | null, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, documentReferences?: Array<{ __typename?: 'DocumentReference', referenceDocumentType?: string | null, reference?: { __typename?: 'Reference', name: string, id: string } | null, requirementReferences: Array<{ __typename?: 'Requirement', id: string, name: string }> }> | null, gearboxVariants: Array<{ __typename?: 'GearboxVariant', id: string, name: string }>, bodyworkVariants: Array<{ __typename?: 'BodyworkVariant', id: string, name: string }>, activeTypeMarkets: Array<{ __typename?: 'ActiveTypeMarket', id: string, name: string }>, engineVariants: Array<{ __typename?: 'EngineVariant', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }> }> };

export type GetRequirementByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetRequirementByIdQuery = { __typename?: 'Query', requirement?: { __typename?: 'Requirement', dateEffective?: any | null, dateExpiration?: any | null, createdAt?: any | null, id: string, name: string, requirementId?: string | null, status: Types.RequirementStatus, category: Types.RequirementCategory, definition?: string | null, modifiedAt?: any | null, version?: string | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, systemLevels: Array<{ __typename?: 'SystemLevel', id: string, name: string, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, successor?: { __typename?: 'Requirement', id: string, name: string } | null, childrenRefs?: Array<{ __typename?: 'Requirement', id: string, version?: string | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, regulations?: Array<{ __typename?: 'Regulation', id: string, regulationNumber: string }> | null, regulatoryDocuments?: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string }> | null, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, documentReferences?: Array<{ __typename?: 'DocumentReference', referenceDocumentType?: string | null, reference?: { __typename?: 'Reference', name: string, id: string } | null, requirementReferences: Array<{ __typename?: 'Requirement', id: string, name: string }> }> | null, gearboxVariants: Array<{ __typename?: 'GearboxVariant', id: string, name: string }>, bodyworkVariants: Array<{ __typename?: 'BodyworkVariant', id: string, name: string }>, activeTypeMarkets: Array<{ __typename?: 'ActiveTypeMarket', id: string, name: string }>, engineVariants: Array<{ __typename?: 'EngineVariant', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }> } | null };

export type GetRequirementsFormDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRequirementsFormDataQuery = { __typename?: 'Query', systemLevels?: Array<{ __typename?: 'SystemLevel', id: string, name: string }> | null, vexClusters?: Array<{ __typename?: 'VexCluster', id: string, name: string }> | null, driveVariants?: Array<{ __typename?: 'DriveVariant', id: string, name: string }> | null, engineVariants?: Array<{ __typename?: 'EngineVariant', id: string, name: string }> | null, gearboxVariants?: Array<{ __typename?: 'GearboxVariant', id: string, name: string }> | null, bodyworkVariants?: Array<{ __typename?: 'BodyworkVariant', id: string, name: string }> | null, activeTypeMarkets?: Array<{ __typename?: 'ActiveTypeMarket', id: string, name: string }> | null, vehicleCategories?: Array<{ __typename?: 'VehicleCategory', id: string, name: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string, name: string }> | null };

export type GetAggregatedFieldsQueryVariables = Types.Exact<{
  input: Types.Scalars['ID'];
}>;


export type GetAggregatedFieldsQuery = { __typename?: 'Query', requirement?: { __typename?: 'Requirement', aggregatedFields: { __typename?: 'AggregatedFields', vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }> } } | null };

export type CreateRequirementMutationVariables = Types.Exact<{
  input: Types.CreateRequirementInput;
}>;


export type CreateRequirementMutation = { __typename?: 'Mutation', createRequirement: { __typename?: 'RequirementPayload', requirement: { __typename?: 'Requirement', id: string } } };

export type UpdateRequirementMutationVariables = Types.Exact<{
  input: Types.UpdateRequirementInput;
}>;


export type UpdateRequirementMutation = { __typename?: 'Mutation', updateRequirement: { __typename?: 'RequirementPayload', requirement: { __typename?: 'Requirement', id: string } } };

export type DeleteRequirementMutationVariables = Types.Exact<{
  input: Types.DeleteRequirementInput;
}>;


export type DeleteRequirementMutation = { __typename?: 'Mutation', deleteRequirement: { __typename?: 'DeleteRequirementPayload', requirement?: { __typename?: 'Requirement', id: string } | null } };

export type RemoveRequirementAssignedParagraphsMutationVariables = Types.Exact<{
  requirementId: Types.Scalars['ID'];
  changes: Array<Types.RequirementParagraphRefInput> | Types.RequirementParagraphRefInput;
}>;


export type RemoveRequirementAssignedParagraphsMutation = { __typename?: 'Mutation', removeRequirementAssignedParagraphs: Array<{ __typename?: 'RequirementParagraphRef', regulationRef: { __typename?: 'EntityRefOfRegulation', id: string }, regdocRef: { __typename?: 'EntityRefOfRegulatoryDocument', id: string }, paragraphRefs: Array<{ __typename?: 'EntityRefOfRegulatoryDocumentParagraph', id: string }> }> };

export type AssignRequirementParagraphsMutationVariables = Types.Exact<{
  input: Types.AssignRequirementParagraphsInput;
}>;


export type AssignRequirementParagraphsMutation = { __typename?: 'Mutation', assignRequirementParagraphs: Array<{ __typename?: 'RequirementParagraphRef', regulationRef: { __typename?: 'EntityRefOfRegulation', id: string }, regdocRef: { __typename?: 'EntityRefOfRegulatoryDocument', id: string }, paragraphRefs: Array<{ __typename?: 'EntityRefOfRegulatoryDocumentParagraph', id: string }> }> };


export const GetAllRequirementsDocument = gql`
    query GetAllRequirements {
  requirements {
    ...RequirementListRequirementFields
    ...FieldsToEditRequirement
    createdAt
  }
}
    ${RequirementListRequirementFieldsFragmentDoc}
${FieldsToEditRequirementFragmentDoc}`;

/**
 * __useGetAllRequirementsQuery__
 *
 * To run a query within a React component, call `useGetAllRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRequirementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRequirementsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRequirementsQuery, GetAllRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRequirementsQuery, GetAllRequirementsQueryVariables>(GetAllRequirementsDocument, options);
      }
export function useGetAllRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRequirementsQuery, GetAllRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRequirementsQuery, GetAllRequirementsQueryVariables>(GetAllRequirementsDocument, options);
        }
export type GetAllRequirementsQueryHookResult = ReturnType<typeof useGetAllRequirementsQuery>;
export type GetAllRequirementsLazyQueryHookResult = ReturnType<typeof useGetAllRequirementsLazyQuery>;
export type GetAllRequirementsQueryResult = Apollo.QueryResult<GetAllRequirementsQuery, GetAllRequirementsQueryVariables>;
export const GetRequirementByIdDocument = gql`
    query GetRequirementById($id: ID!) {
  requirement(id: $id) {
    ...RequirementListRequirementFields
    ...FieldsToEditRequirement
    dateEffective
    dateExpiration
    createdAt
  }
}
    ${RequirementListRequirementFieldsFragmentDoc}
${FieldsToEditRequirementFragmentDoc}`;

/**
 * __useGetRequirementByIdQuery__
 *
 * To run a query within a React component, call `useGetRequirementByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequirementByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequirementByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequirementByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRequirementByIdQuery, GetRequirementByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequirementByIdQuery, GetRequirementByIdQueryVariables>(GetRequirementByIdDocument, options);
      }
export function useGetRequirementByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequirementByIdQuery, GetRequirementByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequirementByIdQuery, GetRequirementByIdQueryVariables>(GetRequirementByIdDocument, options);
        }
export type GetRequirementByIdQueryHookResult = ReturnType<typeof useGetRequirementByIdQuery>;
export type GetRequirementByIdLazyQueryHookResult = ReturnType<typeof useGetRequirementByIdLazyQuery>;
export type GetRequirementByIdQueryResult = Apollo.QueryResult<GetRequirementByIdQuery, GetRequirementByIdQueryVariables>;
export const GetRequirementsFormDataDocument = gql`
    query GetRequirementsFormData {
  systemLevels {
    id
    name
  }
  vexClusters {
    id
    name
  }
  driveVariants {
    id
    name
  }
  engineVariants {
    id
    name
  }
  gearboxVariants {
    id
    name
  }
  bodyworkVariants {
    id
    name
  }
  activeTypeMarkets {
    id
    name
  }
  vehicleCategories {
    id
    name
  }
  tags {
    id
    name
  }
}
    `;

/**
 * __useGetRequirementsFormDataQuery__
 *
 * To run a query within a React component, call `useGetRequirementsFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequirementsFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequirementsFormDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequirementsFormDataQuery(baseOptions?: Apollo.QueryHookOptions<GetRequirementsFormDataQuery, GetRequirementsFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequirementsFormDataQuery, GetRequirementsFormDataQueryVariables>(GetRequirementsFormDataDocument, options);
      }
export function useGetRequirementsFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequirementsFormDataQuery, GetRequirementsFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequirementsFormDataQuery, GetRequirementsFormDataQueryVariables>(GetRequirementsFormDataDocument, options);
        }
export type GetRequirementsFormDataQueryHookResult = ReturnType<typeof useGetRequirementsFormDataQuery>;
export type GetRequirementsFormDataLazyQueryHookResult = ReturnType<typeof useGetRequirementsFormDataLazyQuery>;
export type GetRequirementsFormDataQueryResult = Apollo.QueryResult<GetRequirementsFormDataQuery, GetRequirementsFormDataQueryVariables>;
export const GetAggregatedFieldsDocument = gql`
    query GetAggregatedFields($input: ID!) {
  requirement(id: $input) {
    aggregatedFields {
      vehicleCategories {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAggregatedFieldsQuery__
 *
 * To run a query within a React component, call `useGetAggregatedFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregatedFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregatedFieldsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAggregatedFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetAggregatedFieldsQuery, GetAggregatedFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregatedFieldsQuery, GetAggregatedFieldsQueryVariables>(GetAggregatedFieldsDocument, options);
      }
export function useGetAggregatedFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregatedFieldsQuery, GetAggregatedFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregatedFieldsQuery, GetAggregatedFieldsQueryVariables>(GetAggregatedFieldsDocument, options);
        }
export type GetAggregatedFieldsQueryHookResult = ReturnType<typeof useGetAggregatedFieldsQuery>;
export type GetAggregatedFieldsLazyQueryHookResult = ReturnType<typeof useGetAggregatedFieldsLazyQuery>;
export type GetAggregatedFieldsQueryResult = Apollo.QueryResult<GetAggregatedFieldsQuery, GetAggregatedFieldsQueryVariables>;
export const CreateRequirementDocument = gql`
    mutation CreateRequirement($input: CreateRequirementInput!) {
  createRequirement(input: $input) {
    requirement {
      id
    }
  }
}
    `;
export type CreateRequirementMutationFn = Apollo.MutationFunction<CreateRequirementMutation, CreateRequirementMutationVariables>;

/**
 * __useCreateRequirementMutation__
 *
 * To run a mutation, you first call `useCreateRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRequirementMutation, { data, loading, error }] = useCreateRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRequirementMutation(baseOptions?: Apollo.MutationHookOptions<CreateRequirementMutation, CreateRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRequirementMutation, CreateRequirementMutationVariables>(CreateRequirementDocument, options);
      }
export type CreateRequirementMutationHookResult = ReturnType<typeof useCreateRequirementMutation>;
export type CreateRequirementMutationResult = Apollo.MutationResult<CreateRequirementMutation>;
export type CreateRequirementMutationOptions = Apollo.BaseMutationOptions<CreateRequirementMutation, CreateRequirementMutationVariables>;
export const UpdateRequirementDocument = gql`
    mutation UpdateRequirement($input: UpdateRequirementInput!) {
  updateRequirement(input: $input) {
    requirement {
      id
    }
  }
}
    `;
export type UpdateRequirementMutationFn = Apollo.MutationFunction<UpdateRequirementMutation, UpdateRequirementMutationVariables>;

/**
 * __useUpdateRequirementMutation__
 *
 * To run a mutation, you first call `useUpdateRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequirementMutation, { data, loading, error }] = useUpdateRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRequirementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRequirementMutation, UpdateRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRequirementMutation, UpdateRequirementMutationVariables>(UpdateRequirementDocument, options);
      }
export type UpdateRequirementMutationHookResult = ReturnType<typeof useUpdateRequirementMutation>;
export type UpdateRequirementMutationResult = Apollo.MutationResult<UpdateRequirementMutation>;
export type UpdateRequirementMutationOptions = Apollo.BaseMutationOptions<UpdateRequirementMutation, UpdateRequirementMutationVariables>;
export const DeleteRequirementDocument = gql`
    mutation DeleteRequirement($input: DeleteRequirementInput!) {
  deleteRequirement(input: $input) {
    requirement {
      id
    }
  }
}
    `;
export type DeleteRequirementMutationFn = Apollo.MutationFunction<DeleteRequirementMutation, DeleteRequirementMutationVariables>;

/**
 * __useDeleteRequirementMutation__
 *
 * To run a mutation, you first call `useDeleteRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequirementMutation, { data, loading, error }] = useDeleteRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRequirementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRequirementMutation, DeleteRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRequirementMutation, DeleteRequirementMutationVariables>(DeleteRequirementDocument, options);
      }
export type DeleteRequirementMutationHookResult = ReturnType<typeof useDeleteRequirementMutation>;
export type DeleteRequirementMutationResult = Apollo.MutationResult<DeleteRequirementMutation>;
export type DeleteRequirementMutationOptions = Apollo.BaseMutationOptions<DeleteRequirementMutation, DeleteRequirementMutationVariables>;
export const RemoveRequirementAssignedParagraphsDocument = gql`
    mutation RemoveRequirementAssignedParagraphs($requirementId: ID!, $changes: [RequirementParagraphRefInput!]!) {
  removeRequirementAssignedParagraphs(
    input: {requirementId: $requirementId, requirementParagraphRefsChange: $changes}
  ) {
    regulationRef {
      id
    }
    regdocRef {
      id
    }
    paragraphRefs {
      id
    }
  }
}
    `;
export type RemoveRequirementAssignedParagraphsMutationFn = Apollo.MutationFunction<RemoveRequirementAssignedParagraphsMutation, RemoveRequirementAssignedParagraphsMutationVariables>;

/**
 * __useRemoveRequirementAssignedParagraphsMutation__
 *
 * To run a mutation, you first call `useRemoveRequirementAssignedParagraphsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRequirementAssignedParagraphsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRequirementAssignedParagraphsMutation, { data, loading, error }] = useRemoveRequirementAssignedParagraphsMutation({
 *   variables: {
 *      requirementId: // value for 'requirementId'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useRemoveRequirementAssignedParagraphsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRequirementAssignedParagraphsMutation, RemoveRequirementAssignedParagraphsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRequirementAssignedParagraphsMutation, RemoveRequirementAssignedParagraphsMutationVariables>(RemoveRequirementAssignedParagraphsDocument, options);
      }
export type RemoveRequirementAssignedParagraphsMutationHookResult = ReturnType<typeof useRemoveRequirementAssignedParagraphsMutation>;
export type RemoveRequirementAssignedParagraphsMutationResult = Apollo.MutationResult<RemoveRequirementAssignedParagraphsMutation>;
export type RemoveRequirementAssignedParagraphsMutationOptions = Apollo.BaseMutationOptions<RemoveRequirementAssignedParagraphsMutation, RemoveRequirementAssignedParagraphsMutationVariables>;
export const AssignRequirementParagraphsDocument = gql`
    mutation AssignRequirementParagraphs($input: AssignRequirementParagraphsInput!) {
  assignRequirementParagraphs(input: $input) {
    regulationRef {
      id
    }
    regdocRef {
      id
    }
    paragraphRefs {
      id
    }
  }
}
    `;
export type AssignRequirementParagraphsMutationFn = Apollo.MutationFunction<AssignRequirementParagraphsMutation, AssignRequirementParagraphsMutationVariables>;

/**
 * __useAssignRequirementParagraphsMutation__
 *
 * To run a mutation, you first call `useAssignRequirementParagraphsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRequirementParagraphsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRequirementParagraphsMutation, { data, loading, error }] = useAssignRequirementParagraphsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignRequirementParagraphsMutation(baseOptions?: Apollo.MutationHookOptions<AssignRequirementParagraphsMutation, AssignRequirementParagraphsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignRequirementParagraphsMutation, AssignRequirementParagraphsMutationVariables>(AssignRequirementParagraphsDocument, options);
      }
export type AssignRequirementParagraphsMutationHookResult = ReturnType<typeof useAssignRequirementParagraphsMutation>;
export type AssignRequirementParagraphsMutationResult = Apollo.MutationResult<AssignRequirementParagraphsMutation>;
export type AssignRequirementParagraphsMutationOptions = Apollo.BaseMutationOptions<AssignRequirementParagraphsMutation, AssignRequirementParagraphsMutationVariables>;